<template>
  <div class="product-detail col-xs-12 section">
    <el-progress class="p-b-3"
                 status="success"
                 :class="[progress < 100 && loading ? 'fade-in' : 'fade-out']"
                 :percentage="progress"
                 :show-text="false"/>
    <div class="col-xs-12 section-label hidden-md hidden-lg">
      Product
    </div>
    <div class="hidden-sm hidden-xs col-md-12 desktop-product-title">
      <div class="col-md-5 pl-0 pr-0">
        <div class="col-md-6 col-md-offset-6 pl-0 pr-0">Product</div>
      </div>
      <div class="col-md-6 right-title">
        <span class="col-md-4">Stock</span>
        <span class="col-md-2">QTY</span>
        <span class="col-md-3">Price</span>
        <span class="col-md-3">Total</span>
      </div>
      <div class="col-md-1"></div>
    </div>
    <order-product v-for="(product, key) in products"
                   :product="product"
                   :key="key"/>
  </div>
</template>

<script>
  import {mapGetters, mapState, mapActions, mapMutations} from 'vuex';
  import OrderProduct from './OrderUpdateProduct';
  import {
    ORDER_GET_PRODUCTS_PROGRESS,
    ORDER_SET_PRODUCTS_LOADING,
    ORDER_PRODUCTS_UPDATE_TOTALS,
  } from '../../../store/types';

  export default {
    name: 'OrderProducts',
    inject: ['$v'],
    components: {
      OrderProduct,
    },
    computed: {
      ...mapState({
        loading: state => state.order.products.loading,
        products: state => state.order.products.items,
      }),
      ...mapGetters({
        progress: ORDER_GET_PRODUCTS_PROGRESS,
      }),
    },
    methods: {
      ...mapMutations({
        isLoading: ORDER_SET_PRODUCTS_LOADING,
      }),
      ...mapActions({
        updateDiscounts: ORDER_PRODUCTS_UPDATE_TOTALS,
      }),
    },
    watch: {
      progress: function(progress) {
        if (progress > 99) {
          this.isLoading(false);
          this.updateDiscounts();
        }
      },
    },
  };
</script>
